<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>WTI - {{this.subTitle}}</h2>
			</b-col>
			<!--Gear Icon-->
			<b-col lg="6">
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
						<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editWti">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteWti">Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>

		<div>
			<b-card v-if="loadingData">
				<b-col cols="12" sm="12" md="12" lg="12">
					<p class="text-center">
						<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
					</p>
				</b-col>
			</b-card>
			<div v-else>
				<b-card v-if="found">
						<b-row>
							<b-col md="8">
								<b-form-group :label-cols="4" horizontal label="Settle Date" label-for="settle_date">
									<b-form-input class="plaintext-input" v-show="!edit" plaintext id="settle_date" v-model="show.settle_date" type="text"></b-form-input>
									<b-form-input class="plaintext-input" v-show="edit" id="settle_date" v-model="model.settle_date" type="date"></b-form-input>
								</b-form-group>

  								<b-form-group :label-cols="4" horizontal label="Future" label-for="future">
									<b-form-input class="plaintext-input" v-show="!edit" plaintext id="future" v-model="show.future" type="text"></b-form-input>
									<b-form-input class="plaintext-input" v-show="edit" id="future" v-model="model.future" type="date"></b-form-input>
								</b-form-group>      				

								<b-form-group :label-cols="4" horizontal label="WTI" label-for="wti">
									<b-form-input class="plaintext-input" v-show="edit" id="wti" v-model="model.wti" type="text" @keydown.native="myOnlyNumber($event, 'rate')"></b-form-input>
									<b-form-input class="plaintext-input" v-show="!edit" plaintext id="wti" v-model="show.wti" type="text" ></b-form-input>
								</b-form-group>

								<b-form-group :label-cols="4" horizontal label="Forex" label-for="forex">
									<b-form-input class="plaintext-input" v-show="edit" id="forex" v-model="model.forex" type="text" @keydown.native="myOnlyNumber($event, 'rate')"></b-form-input>
									<b-form-input class="plaintext-input" v-show="!edit" plaintext id="forex" v-model="show.forex" type="text"></b-form-input>
								</b-form-group>

								<div slot="footer" v-show="edit">
									<b-button @click="updateWti" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
									<b-button @click="editWti" size="sm"><i class="fa fa-ban"></i> Cancel</b-button>
								</div>
							</b-col>
						</b-row>
					<!-- </b-tab> -->
				</b-card>
				<b-row v-else>
					<b-col cols="12" sm="12" md="12" lg="12">
						<br>
						<p class="text-center text-danger">
							<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
						</p>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
	import t_agreement from './t_agreement'
  	import moment from 'moment';

	export default {
		name: 'WtiDetail',
		created: function() {
			this.getWti()
		},
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		data() {
			return {
				subTitle		: '',
				edit			: false,
				found			: true,
				notFoundMessage	: 'Not found',
				model       	: {
                    future        : null,
                    settle_date   : null,
                    wti           : null,
                    forex         : null
        		},
				updateData		: null,
				originalData	: null,
				loadingData		: false,
				rate			: '',
				wtiId			: '',
				show       	: {
					settle_date	  : '',
					future   	  : '',
          			wti           : '',
          			forex         : ''
        		},
			}
		},
		methods: {
			myOnlyNumber(evt, variableName) {
					let dotPosition = this[variableName].indexOf(".")
					let hasDot = dotPosition > -1
					let length = this[variableName].length
					this.isNumber(evt, hasDot, dotPosition, length)
			},
			isNumber: function(evt, hasDot, dotPosition, length) {
					evt = (evt) ? evt : window.event;
					var charCode = (evt.which) ? evt.which : evt.keyCode;
					if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
					// if (charCode <= 31 || charCode == 37 || charCode == 39 || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190))) {
						let selectionStart = evt.target.selectionStart;
						let selectionEnd = evt.target.selectionEnd;
						if ((hasDot && selectionEnd > dotPosition && length - 2 > dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
							evt.preventDefault();
						} else {
							return true
						}
					} else {
						evt.preventDefault();
					}
			},
			editWti() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.edit = true
				}
			},
			restoreOriginalData() {
				let model = {
                    settle_date   : this.originalData.settle_date,
                    future        : this.originalData.future,
          			wti           : this.originalData.wti,
          			forex         : this.originalData.forex
				}
				this.model  = model
				let show       	= {
					settle_date	  : moment(this.originalData.settle_date).format("MMM DD, YYYY"),
					future	  	  : moment(this.originalData.future).format("MMM-YYYY"),
          			wti           : this.format(this.originalData.wti),
          			forex         : this.originalData.forex,
				}
				this.show=show
			},
			format(value){
				if (value==null) {
                  return 'None'
				} else {
				  return '$'+value
				}
			},
			getWti() {
				t_agreement.getByWti(this.id)
					.then(data => {
						if (data.status == 'success') {
							this.originalData 	= data.wti
							
							this.wtiId  		= this.id
							this.loadingData 	= false
							this.found 			= true
							this.restoreOriginalData()
							
							this.subTitle 		= moment(this.originalData.settle_date).format("MMM DD, YYYY")
							
						} else {
              				this.$swal(data.status, data.message, data.status)
              				this.loadingData = false
              				return
            			}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
        		if(this.model.settle_date == null) {
						this.$swal('Alert!', 'Settle Date not selected', 'warning')
						return false
					} else if(this.model.future == null) {
						this.$swal('Alert!', 'Future not selected', 'warning')
						return false
					} else if(this.model.wti == null) {
						this.$swal('Alert!', 'WTI cannot be empty', 'warning')
						return false
					} else if(this.model.forex == null) {
						this.$swal('Alert!', 'Forex cannot be empty', 'warning')
						return false
          		}
				return true
			},
      		updateWti () {
        		if (!this.okToUpdate()) {
					return
				}

				t_agreement.update_wti(this.wtiId, this.model)
					.then((data) => {
						this.$swal(data[0], data[1], data[0])
							.then((result) => {
								this.getWti()
							})
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
					this.edit=false
			},
			deleteWti(item) {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this WTI " + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						t_agreement.delete_wti(this.wtiId)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.$router.replace('/wti')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/terminal_agreements/wti_detail.vue